import {
  IconAdjustmentsAlt,
  IconAdjustmentsHorizontal,
  IconAlertTriangleFilled,
  IconArrowBackUp,
  IconArrowBarToDown,
  IconArrowDown,
  IconArrowDownCircle,
  IconArrowForwardUp,
  IconArrowLeft,
  IconArrowNarrowDown,
  IconArrowNarrowUp,
  IconArrowRight,
  IconArrowRightCircle,
  IconArrowUp,
  IconArrowsSort,
  IconBell,
  IconBrandOnedrive,
  IconBuilding,
  IconBuildingBank,
  IconBuildingSkyscraper, // Note: The image shows a colored version of this icon
  IconCalendar,
  IconCalendarWeek,
  IconCamera,
  IconCash,
  IconChartBar,
  IconChartPie3, // Note: The image shows a colored version of this icon
  IconCheck,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconCircleCheck, // Note: The image shows this with a custom red background
  IconCircleCheckFilled,
  IconCircleFilled,
  IconCircleX,
  IconCircleXFilled,
  IconClipboard,
  IconClipboardOff,
  IconCloud,
  IconCloudUpload,
  IconCopy,
  IconCreditCard,
  IconDeviceFloppy,
  IconDots,
  IconDotsVertical,
  IconDownload,
  IconEdit,
  IconEye,
  IconEyeOff,
  IconFile,
  IconFileArrowRight,
  IconFileChart,
  IconFileCheck,
  IconFileOff,
  IconFilePlus,
  IconFileSearch,
  IconFileSpreadsheet,
  IconFileStack,
  IconFileText,
  IconFileTypeDoc,
  IconFileTypeDocx,
  IconFileTypeJpg,
  IconFileTypePdf,
  IconFileTypePng,
  IconFileTypeZip,
  IconFiles,
  IconFolderCog,
  IconGift,
  IconGripVertical, // (folder with settings icon)
  IconHandMove,
  IconHistory,
  IconHome,
  IconInfoCircle,
  IconLayoutGrid,
  IconLayoutList,
  IconLink,
  IconLock,
  IconLockPassword,
  IconLogin,
  IconLogout,
  IconMapPin,
  IconMenu2,
  IconMessage,
  IconMessage2,
  IconMessageCircle,
  IconMessageQuestion,
  IconMessageReport,
  IconMessageX,
  IconMicrophone,
  IconNoteOff,
  IconPaperclip,
  IconPencil,
  IconPhone,
  IconPhoto,
  IconPlus,
  IconReceipt,
  IconRefresh,
  IconRepeat,
  IconReport,
  IconRobot, // Note: The image shows a colored version of this icon
  IconScale,
  IconSearch,
  IconSend,
  IconSettings,
  IconSignLeft,
  IconSignature,
  IconStack2,
  IconStar,
  IconStarFilled,
  IconTableShare,
  IconTrash,
  IconTrendingDown3,
  IconTrendingUp3,
  IconTruck, // Note: The image shows a colored version of this icon
  IconUpload,
  IconUserCheck,
  IconUserCircle,
  IconUserCog,
  IconUserDown,
  IconUserEdit,
  IconUserPlus,
  IconUserShield,
  IconUserStar,
  IconUsers,
  IconWritingSign,
  IconX,
  IconZoomIn,
  IconZoomOut,
  IconPrinter,
  IconCircleArrowDown,
  IconChevronsLeft,
  IconChevronsRight,
  IconAlertTriangle
} from 'angular-tabler-icons/icons';

// for import in app.config.ts
export const IconsList = {
  IconAdjustmentsAlt,
  IconAdjustmentsHorizontal,
  IconAlertTriangleFilled,
  IconArrowBarToDown,
  IconArrowDown,
  IconArrowDownCircle,
  IconArrowLeft,
  IconArrowRight,
  IconArrowRightCircle,
  IconArrowUp,
  IconArrowNarrowUp,
  IconArrowNarrowDown,
  IconArrowsSort,
  IconArrowBackUp,
  IconArrowForwardUp,
  IconBell,
  IconBuilding,
  IconBuildingBank,
  IconBuildingSkyscraper,
  IconCalendar,
  IconCalendarWeek,
  IconCamera,
  IconCash,
  IconCheck,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconClipboard,
  IconClipboardOff,
  IconCircleFilled,
  IconCircleCheckFilled,
  IconCircleX,
  IconCircleXFilled,
  IconCloud,
  IconCloudUpload,
  IconCopy,
  IconCreditCard,
  IconChartBar,
  IconChartPie3,
  IconDeviceFloppy,
  IconDots,
  IconDotsVertical,
  IconDownload,
  IconEye,
  IconEyeOff,
  IconFile,
  IconFiles,
  IconFileArrowRight,
  IconFileCheck,
  IconFileOff,
  IconFilePlus,
  IconFileSearch,
  IconFileStack,
  IconFileTypeDoc,
  IconFileTypePdf,
  IconFileTypePng,
  IconFileChart,
  IconFolderCog,
  IconGripVertical,
  IconHandMove,
  IconHome,
  IconHistory,
  IconInfoCircle,
  IconLayoutGrid,
  IconLayoutList,
  IconLink,
  IconLock,
  IconLockPassword,
  IconLogin,
  IconLogout,
  IconMapPin,
  IconMenu2,
  IconMessage,
  IconMessage2,
  IconMessageCircle,
  IconMessageReport,
  IconMicrophone,
  IconPaperclip,
  IconPencil,
  IconPhone,
  IconPhoto,
  IconPlus,
  IconReceipt,
  IconRepeat,
  IconReport,
  IconRefresh,
  IconRobot,
  IconScale,
  IconSearch,
  IconSend,
  IconSettings,
  IconSignature,
  IconStar,
  IconStarFilled,
  IconTrash,
  IconTruck,
  IconTrendingUp3,
  IconTrendingDown3,
  IconTableShare,
  IconUpload,
  IconUserCheck,
  IconUserCircle,
  IconUserShield,
  IconUserCog,
  IconUserDown,
  IconUserPlus,
  IconUserStar,
  IconUserEdit,
  IconX,
  IconWritingSign,
  IconZoomIn,
  IconZoomOut,
  IconEdit,
  IconCircleCheck,
  IconNoteOff,
  IconMessageQuestion,
  IconGift,
  IconSignLeft,
  IconStack2,
  IconUsers,
  IconPrinter,
  IconCircleArrowDown,
  IconChevronsLeft,
  IconChevronsRight,
  IconFileText,
  IconAlertTriangle
};

export enum TablerIcon {
  AdjustmentsAlt = 'adjustments-alt',
  AdjustmentsHorizontal = 'adjustments-horizontal',
  AlertTriangleFilled = 'alert-triangle-filled',
  ArrowBarToDown = 'arrow-bar-to-down',
  ArrowDown = 'arrow-down',
  ArrowDownCircle = 'arrow-down-circle',
  ArrowLeft = 'arrow-left',
  ArrowRight = 'arrow-right',
  ArrowRightCircle = 'arrow-right-circle',
  ArrowUp = 'arrow-up',
  ArrowNarrowUp = 'arrow-narrow-up',
  ArrowNarrowDown = 'arrow-narrow-down',
  ArrowsSort = 'arrows-sort',
  ArrowBackUp = 'arrow-back-up',
  ArrowForwardUp = 'arrow-forward-up',
  Bell = 'bell',
  BrandOneDrive = 'brand-onedrive',
  Building = 'building',
  BuildingBank = 'building-bank',
  BuildingSkyscraper = 'building-skyscraper',
  Calendar = 'calendar',
  CalendarWeek = 'calendar-week',
  Camera = 'camera',
  Cash = 'cash',
  Check = 'check',
  ChevronDown = 'chevron-down',
  ChevronLeft = 'chevron-left',
  ChevronRight = 'chevron-right',
  ChevronUp = 'chevron-up',
  Clipboard = 'clipboard',
  ClipboardOff = 'clipboard-off',
  CircleFilled = 'circle-filled',
  CircleCheck = 'circle-check',
  CircleCheckFilled = 'circle-check-filled',
  CircleX = 'circle-x',
  CircleXFilled = 'circle-x-filled',
  Cloud = 'cloud',
  CloudUpload = 'cloud-upload',
  Copy = 'copy',
  CreditCard = 'credit-card',
  ChartBar = 'chart-bar',
  ChartPie = 'chart-pie-3',
  DeviceFloppy = 'device-floppy',
  Dots = 'dots',
  DotsVertical = 'dots-vertical',
  Download = 'download',
  Edit = 'edit',
  Eye = 'eye',
  EyeOff = 'eye-off',
  File = 'file',
  Files = 'files',
  FileArrowRight = 'file-arrow-right',
  FileCheck = 'file-check',
  FileOff = 'file-off',
  FilePlus = 'file-plus',
  FileSearch = 'file-search',
  FileStack = 'file-stack',
  FileTypeDoc = 'file-type-doc',
  FileTypePdf = 'file-type-pdf',
  FileTypePng = 'file-type-png',
  FileTypeJpg = 'file-type-jpg',
  FileTypeZip = 'file-type-zip',
  FileTypeDocx = 'file-type-docx',
  FileSpreadsheet = 'file-spreadsheet',
  FileText = 'file-text',
  FileChart = 'file-chart',
  Folder = 'folder',
  FolderPlus = 'folder-plus',
  FolderFilled = 'folder-filled',
  FolderCog = 'folder-cog',
  FolderShare = 'folder-share',
  GripVertical = 'grip-vertical',
  HandMove = 'hand-move',
  Home = 'home',
  History = 'History',
  InfoCircle = 'info-circle',
  LayoutGrid = 'layout-grid',
  LayoutList = 'layout-list',
  Link = 'link',
  Lock = 'lock',
  LockPassword = 'lock-password',
  Login = 'login',
  Logout = 'logout',
  MapPin = 'map-pin',
  Menu2 = 'menu-2',
  Message = 'message',
  Message2 = 'message-2',
  MessageCircle = 'message-circle',
  MessageReport = 'message-report',
  MessageQuestion = 'message-question',
  MessageX = 'message-x',
  Microphone = 'microphone',
  NoteOff = 'note-off',
  Paperclip = 'paperclip',
  Pencil = 'pencil',
  Phone = 'phone',
  Photo = 'photo',
  Plus = 'plus',
  Receipt = 'receipt',
  Repeat = 'repeat',
  Report = 'report',
  ReportAnalytics = 'report-analytics',
  Refresh = 'refresh',
  Robot = 'robot',
  Scale = 'scale',
  Search = 'search',
  Send = 'send',
  Settings = 'settings',
  Signature = 'signature',
  Star = 'star',
  StarFilled = 'star-filled',
  Trash = 'trash',
  Truck = 'truck',
  TrendingUp3 = 'trending-up-3',
  TrendingDown3 = 'trending-down-3',
  TableShare = 'table-share',
  Upload = 'upload',
  Users = 'users',
  UserCheck = 'user-check',
  UserCircle = 'user-circle',
  UserCog = 'user-cog',
  UserShield = 'user-shield',
  UserDown = 'user-down',
  UserPlus = 'user-plus',
  UserStar = 'user-star',
  UserEdit = 'user-edit',
  X = 'x',
  WritingSign = 'writing-sign',
  ZoomIn = 'zoom-in',
  ZoomOut = 'zoom-out',
  Gift = 'gift',
  SignLeft = 'sign-left',
  Stack2 = 'stack-2',
  printer = 'printer',
  circlearrowdown = 'circle-arrow-down',
  chevronsleft= 'chevrons-left',
  chevronsright = 'chevrons-right',
  alerttriangle= 'alert-triangle'
}
